/**
 * Italian legal copy — mirror of the JSX hardcoded in the legal pages
 * before this refactor. Acts as the fallback source of truth for every
 * locale that has not yet been translated.
 *
 * Schema:
 *   {
 *     preamble?: Array<{type: 'para' | 'contact', text?: string,
 *                       label?: string, value?: string, mailto?: boolean}>,
 *     sections: Array<{
 *       number?: string | number,
 *       title: string,
 *       blocks: Array<{type: 'para' | 'list', text?: string, items?: string[]}>
 *     }>
 *   }
 */

const it = {
    terms: {
        preamble: [
            { type: "para", text: 'Other Side è una piattaforma digitale operata da Laura Stella, operante sotto il nome "Other Side".' },
        ],
        sections: [
            { number: 1, title: "Natura del servizio", blocks: [
                { type: "para", text: "Other Side utilizza tecnologie di intelligenza artificiale per generare esperienze simulate basate sui contenuti forniti dagli utenti." },
                { type: "para", text: "Le interazioni generate non rappresentano comunicazioni reali né implicano la presenza o coscienza della persona rappresentata." },
            ]},
            { number: 2, title: "Requisiti di utilizzo", blocks: [
                { type: "para", text: "L'utente deve avere almeno 18 anni e utilizzare il servizio nel rispetto delle leggi applicabili." },
            ]},
            { number: 3, title: "Responsabilità sui contenuti", blocks: [
                { type: "para", text: "L'utente è responsabile dei contenuti caricati e dichiara di avere il diritto di utilizzarli." },
            ]},
            { number: 4, title: "Persone rappresentate", blocks: [
                { type: "para", text: "L'utente garantisce di non violare diritti di terzi, inclusi diritti relativi a persone decedute." },
            ]},
            { number: 5, title: "Uso vietato", blocks: [
                { type: "para", text: "È vietato l'uso del servizio per finalità illegali, fraudolente o lesive dei diritti altrui." },
            ]},
            { number: 6, title: "Limitazione di responsabilità", blocks: [
                { type: "para", text: "Other Side non è responsabile per interpretazioni soggettive, reazioni emotive o uso improprio del servizio." },
            ]},
            { number: 7, title: "Interruzione", blocks: [
                { type: "para", text: "Il servizio può essere sospeso o limitato in caso di violazioni." },
            ]},
            { number: 8, title: "Diritti dell'utente", blocks: [
                { type: "para", text: "L'utente può richiedere accesso, modifica o cancellazione dei propri dati." },
            ]},
            { number: 9, title: "Modifiche", blocks: [
                { type: "para", text: "I termini possono essere aggiornati in qualsiasi momento." },
            ]},
            { number: 10, title: "Legge applicabile", blocks: [
                { type: "para", text: "Il servizio è regolato dalla normativa europea applicabile." },
            ]},
        ],
    },

    privacy: {
        preamble: [
            { type: "contact", label: "Titolare del trattamento", value: 'Laura Stella, operante sotto il nome "Other Side"' },
            { type: "contact", label: "Email", value: "os.otherside.app@gmail.com", mailto: true },
        ],
        sections: [
            { number: 1, title: "Tipologia di dati raccolti", blocks: [
                { type: "list", items: [
                    "Dati identificativi",
                    "Contenuti caricati (immagini, audio, video)",
                    "Dati biometrici (voce, immagini)",
                    "Dati tecnici (IP, device, log)",
                ]},
            ]},
            { number: 2, title: "Finalità", blocks: [
                { type: "list", items: [
                    "Fornitura del servizio",
                    "Generazione contenuti AI",
                    "Sicurezza e miglioramento",
                ]},
            ]},
            { number: 3, title: "Base giuridica", blocks: [
                { type: "list", items: [
                    "Consenso esplicito",
                    "Esecuzione del servizio",
                ]},
            ]},
            { number: 4, title: "Dati biometrici", blocks: [
                { type: "para", text: "I dati biometrici sono trattati solo previo consenso esplicito dell'utente." },
            ]},
            { number: 5, title: "Conservazione", blocks: [
                { type: "para", text: "I dati sono conservati per il tempo necessario al servizio." },
            ]},
            { number: 6, title: "Diritti dell'utente", blocks: [
                { type: "para", text: "Accesso, rettifica, cancellazione, limitazione, opposizione." },
            ]},
            { number: 7, title: "Trasferimenti", blocks: [
                { type: "para", text: "I dati possono essere trattati su server situati nell'Unione Europea o al di fuori, nel rispetto delle normative applicabili." },
            ]},
            { number: 8, title: "Sicurezza", blocks: [
                { type: "para", text: "Sono adottate misure tecniche e organizzative per proteggere i dati." },
            ]},
            { number: 9, title: "Reclami", blocks: [
                { type: "para", text: "L'utente può rivolgersi all'autorità garante competente." },
            ]},
        ],
    },

    biometric: {
        preamble: [
            { type: "para", text: "L'utente presta consenso esplicito al trattamento di:" },
        ],
        sections: [
            { title: "Dati biometrici coinvolti", blocks: [
                { type: "list", items: ["immagini", "voce", "contenuti audio e video"] },
                { type: "para", text: "ai fini della creazione dell'esperienza digitale." },
            ]},
            { title: "Natura del consenso", blocks: [
                { type: "para", text: "Il consenso è:" },
                { type: "list", items: ["libero", "informato", "revocabile"] },
            ]},
            { title: "Revoca", blocks: [
                { type: "para", text: "La revoca può avvenire in qualsiasi momento tramite le impostazioni dell'account o richiesta diretta." },
            ]},
        ],
    },

    ai_notice: {
        preamble: [
            { type: "para", text: "Other Side utilizza sistemi di intelligenza artificiale." },
        ],
        sections: [
            { title: "Le interazioni", blocks: [
                { type: "list", items: [
                    "sono generate artificialmente",
                    "possono simulare voce, stile e contenuti",
                    "non rappresentano comunicazioni reali",
                ]},
            ]},
            { title: "Limiti del sistema", blocks: [
                { type: "para", text: "Il servizio non ricrea coscienza o identità reale." },
                { type: "para", text: "L'utente accetta di interagire con un sistema AI e ne comprende i limiti." },
            ]},
        ],
    },

    memorial: {
        preamble: [
            { type: "para", text: "Other Side consente la creazione di esperienze basate su contenuti relativi a persone." },
        ],
        sections: [
            { number: 1, title: "Responsabilità", blocks: [
                { type: "para", text: "L'utente è responsabile dei contenuti caricati." },
            ]},
            { number: 2, title: "Persone decedute", blocks: [
                { type: "para", text: "L'utente dichiara di avere il diritto o autorizzazione all'utilizzo dei contenuti." },
            ]},
            { number: 3, title: "Diritti dei familiari", blocks: [
                { type: "para", text: "Eventuali richieste di rimozione o modifica possono essere effettuate da soggetti legittimati." },
            ]},
            { number: 4, title: "Segnalazioni", blocks: [
                { type: "para", text: "Other Side si riserva il diritto di rimuovere contenuti contestati." },
            ]},
            { number: 5, title: "Limitazioni", blocks: [
                { type: "para", text: "Il servizio non garantisce accuratezza storica o rappresentazione reale." },
            ]},
        ],
    },
};

export default it;
